<ll-titulo>Editar Contenido</ll-titulo>
<ll-toolnavbar></ll-toolnavbar>

<plan-personal-contenido-edit
    [contenidoId]="contenidoId"
    [planificacionId]="planificacionId"
></plan-personal-contenido-edit>
